import api from './api'
import type {
  AddProspectRequest,
  BulkAddProspectsRequest,
  JobProspect,
  JobProspectDetail,
  ListProspectsParams,
  ProspectsListResponse,
} from '@/types'

const jobProspectService = {
  async addProspect(data: AddProspectRequest): Promise<JobProspect> {
    const response = await api.post('/v1/job-prospects', data)
    return response.data
  },

  async bulkAddProspects(
    data: BulkAddProspectsRequest
  ): Promise<{ added: number; skipped: number }> {
    const response = await api.post('/v1/job-prospects/bulk', data)
    return response.data
  },

  async listProspects(params: ListProspectsParams): Promise<ProspectsListResponse> {
    const { recruiterJobId, source, offerStatus, page = 1, limit = 20, includeRemoved } = params
    const query = new URLSearchParams({
      recruiterJobId,
      page: page.toString(),
      limit: limit.toString(),
      ...(source && { source }),
      ...(offerStatus && { offerStatus }),
      ...(includeRemoved && { includeRemoved: 'true' }),
    })
    const response = await api.get(`/v1/job-prospects?${query}`)
    return response.data
  },

  async getProspect(id: string): Promise<JobProspectDetail> {
    const response = await api.get(`/v1/job-prospects/${id}`)
    return response.data
  },

  async updateProspect(id: string, data: { notes?: string }): Promise<JobProspect> {
    const response = await api.patch(`/v1/job-prospects/${id}`, data)
    return response.data
  },

  async removeProspect(id: string): Promise<void> {
    await api.delete(`/v1/job-prospects/${id}`)
  },
}

export default jobProspectService
